import { MouseEventHandler, ReactNode } from 'react';

import { SECTION_ID } from '../../../../constants';

import styles from './WriteBoardTemplate.module.css';

interface IWriteBoardProps {
  contentView: ReactNode;
  onContentClick?: MouseEventHandler<HTMLDivElement>;
}

export function WriteBoardTemplate({ contentView, onContentClick }: IWriteBoardProps) {
  return (
    <section id={SECTION_ID.WRITE_BOARD} className={styles['write-board']}>
      <div className={styles['write-board__content']} onClick={onContentClick}>
        {contentView}
      </div>
    </section>
  );
}
